import * as React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { SectionContainer } from './Components/styles';
import ContentFeature from './Components/ContentFeature';
import ContentHighlights from './Components/ContentHighlights';
import ScrollAnimation from './Components/ScrollAnimation';

export default function FeaturesSection() {

    return (
        <div id="whyus">
            <Container maxWidth="lg">
                <SectionContainer>
                    <ScrollAnimation animateIn="fadeInRight" delay={0.5}>
                        <Box sx={{ position: 'relative', display: 'inline-block' }}>
                            <Typography variant="h2" sx={{ color: 'white', mt: 4, fontSize: '44px', fontWeight: 700, lineHeight: 1.3, letterSpacing: '-1.76px', mb: 4 }}>
                                Why use Scriptu for LinkedIn?
                            </Typography>

                            <Box sx={{
                                position: 'absolute',
                                bottom: 0, // Adjust the value as needed
                                left: 0,
                                right: 0,
                                zIndex: 0,
                                marginBottom: '5px',
                                rotate: '180deg',
                                height: '1.90rem',
                                backgroundImage: 'url(/dual-underline.svg)',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }} />
                        </Box>
                    </ScrollAnimation>

                    <ContentFeature
                        title="Boost your LinkedIn engagement by 10x"
                        description="Create engaging LinkedIn posts that resonate with your audience. Our AI-powered post generator helps you generate high-quality content in seconds, so you can focus on growing your brand and business."
                        buttonText="Get Started"
                        imageSrc="/images/landing/post_generator.png"
                        imageAlt="Editor"
                        imageFirst={false}
                    />

                    <ContentHighlights
                        title="AI Post Generators"
                        highlights={[
                            {
                                title: "Topic/Idea Generator",
                                description: "Generate ideas for your LinkedIn posts based on your preferences and industry trends."
                            },
                            {
                                title: "Website/Blog Post Generator",
                                description: "Create LinkedIn posts from a website or blog posts",
                            },
                            {
                                title: "YouTube Video Post Generator",
                                description: "Create LinkedIn posts from YouTube videos",
                            },
                            {
                                title: "Document and Free Text Post Generator",
                                description: "Create LinkedIn posts from Word, PDF, Excel, PowerPoint documents and free text",
                            },
                        ]}
                        buttonText="Get Started"
                        imageSrc="/images/landing/ai_generators.png"
                        imageAlt="Editor"
                        imageFirst={true}
                    />

                    <ContentHighlights
                        title=" Elevate Your Content"
                        highlights={[
                            {
                                title: "AI-Enhanced Hooks & Calls to Action",
                                description: "Instantly generate compelling starters and persuasive calls to action, ensuring your posts grab attention and drive interaction."
                            },
                            {
                                title: "Quick Actions for Post Enhancement",
                                description: "Utilize a suite of tools for quick edits and improvements, making your content not just seen, but memorable."
                            },
                            {
                                title: "Custom AI Chat for Personalized Advice",
                                description: "Dive deeper into content refinement with our AI chat, offering tailored suggestions to elevate your post's impact.."
                            },
                        ]}
                        buttonText="Get Started"
                        imageSrc="/images/landing/improve_post.png"
                        imageAlt="Editor"
                        imageFirst={false}
                    />

                    <ContentHighlights
                        title="Post Readibility"
                        highlights={[
                            {
                                title: "Readibility Score",
                                description: "Ensure your posts are easy to read and understand with our readability score feature.",
                            },
                            {
                                title: "Measure Post Strength",
                                description: "Get insights into your post's strength and make data-driven decisions to improve your content.",
                            },
                        ]}
                        buttonText="Get Started"
                        imageSrc="/images/landing/post_strength.png"
                        imageAlt="Editor"
                        imageFirst={true}
                    />

                    <ContentFeature
                        title="Schedule your posts in advance"
                        description="Plan your LinkedIn posts in advance and schedule them to go live at the best times for your audience. Easily manage your content calendar and stay organized with our scheduling tool."
                        buttonText="Get Started"
                        imageSrc="/images/landing/schedule.png"
                        imageAlt="Editor"
                        imageFirst={false}
                    />

                    <ContentHighlights
                        title="Carousel Maker"
                        highlights={[
                            {
                                title: "Create Carousel Posts",
                                description: "Easily create carousel posts for LinkedIn with our carousel maker tool.",
                            },
                            {
                                title: "Customize Carousel Posts",
                                description: "Customize your carousel posts with images, text, and links to showcase your content.",
                            },
                            {
                                title: "Easily drag and drop",
                                description: "Drag and drop images and text to create stunning carousel posts in minutes.",
                            },
                            {
                                title: "Save and Edit",
                                description: "Save your carousel posts and edit them later to make changes or updates.",
                            },
                            {
                                title: "Use our AI to generate carousel posts",
                                description: "Use our AI to generate carousel posts from your content, documents, youtube videos, and more.",
                            }
                        ]}
                        buttonText="Get Started"
                        imageSrc="/images/landing/carousel.png"
                        imageAlt="Editor"
                        imageFirst={true}
                    />

                    <ContentHighlights
                        title="Media Library"
                        highlights={[
                            {
                                title: "Upload Images, Videos, and PDFs",
                                description: "Upload images and videos to use in your LinkedIn posts.",
                            },
                            {
                                title: "AI-Generated Images",
                                description: "Generate images using AI to enhance your LinkedIn posts.",
                            },
                            {
                                title: "Extensive Photo and Video Library",
                                description: "Access an extensive library of photos and videos to use in your LinkedIn posts.",
                            },
                        ]}
                        buttonText="Get Started"
                        imageSrc="/images/landing/post_media.png"
                        imageAlt="Editor"
                        imageFirst={false}
                    />
                </SectionContainer>
            </Container>
        </div>
    );
}
